<template>
  <naj-modal
    ref="attachmentsListModal"
    :width="1500"
    :footer="true"
    :close-button="true"
    :show-footer-close-button="true"
    @onClose="closeAttachmentsListModal"
  >
    <v-row>
      <v-col cols="2">
        <template v-for="(doc ,index) in attachmentsList">
          <div
            :key="index"
            :class="['row my-5 header-text attachment-entry py-2',{'outlined':index == selectedAttachmentIndex}]"
            @click="getAttachmentDocument(index)"
          >
            <div class="py-1 text-c-green col-6">
              {{ local.attachments.attachmentName }}
            </div>
            <div class="py-1 text-info-value col-6">
              {{ doc.fileName }}
            </div>
          </div>
        </template>
      </v-col>

      <v-col cols="10">
        <div class="preview-holder">
          <div
            v-if="loading"
            class="loader-holder"
          >
            <naj-loader></naj-loader>
          </div>
          <template v-else>
            <image-editor
              v-if="selectedAttachmentIsImage"
              :image-url="fileUrl"
              :image-name="selectedAttachment.fileName"
              :preview-mode="true"
            ></image-editor>

            <template v-else>
              <div
                v-if="document"
                class="attachment-file-viewer pdf-file"
              >
                <div
                  v-if="selectedAttachment.sharepointId"
                  class="pdf-container"
                >
                  <div class="pdf-wrapper">
                    <div class="pdf-holder">
                      <embed :src="fileUrl">
                    </div>
                  </div>
                </div>
                <p
                  v-else
                  class="document-text"
                >
                  {{ document }}
                </p>
              </div>
            </template>
          </template>
        </div>
      </v-col>
    </v-row>
  </naj-modal>
</template>

<script>
import { getBlobUrl } from '@/modules/lawsuit/helpers/utils';

import { createNamespacedHelpers } from 'vuex';
const { mapActions } = createNamespacedHelpers('CasesModule');

import ImageEditor from './image-editor';

export default {
  name: 'AttachmentsListModal',
  components: { ImageEditor },
  props: {
    attachmentsList: {
      type: Array,
      required: true,
    },
    modalVisibility: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
      document: null,
      selectedAttachmentIndex: 0,
    };
  },
  computed: {
    fileUrl() {
      return getBlobUrl(this.document, this.selectedAttachmentIsImage);
    },
    selectedAttachment() {
      return ((this.attachmentsList || [])[this.selectedAttachmentIndex]) || {};
    },
    selectedAttachmentIsImage() {
      const fileTypeIdentifier = this.selectedAttachment.extension || this.selectedAttachment.fileName || '';
      return false;//fileTypeIdentifier.indexOf('pdf') < 0;
    },
  },
  watch: {
    modalVisibility(newValue) {
      if (newValue) {
        this.$refs.attachmentsListModal.show();
        if (this.selectedAttachment.sharepointId) {
          this.getAttachmentDocument(this.selectedAttachmentIndex);
        }
      } else {
        this.$refs.attachmentsListModal.close();
      }
    },
  },
  mounted() { },
  methods: {
    ...mapActions(['getTrustedSourceAttachment']),
    closeAttachmentsListModal() {
      this.resetData();
      this.$emit('modalClose');
    },
    resetData() {
      this.document = null;
      this.loading = false;
      this.selectedAttachmentIndex = 0;
    },
    getAttachmentDocument(index) {
      this.selectedAttachmentIndex = index;
      if (!this.selectedAttachment.sharepointId) {
        this.document = '';
        return;
      }

      this.loading = true;
      this.getTrustedSourceAttachment(this.selectedAttachment.sharepointId)
        .then((attachment) => {
          //const contentType = this.selectedAttachmentIsImage ? 'image/png' : 'application/pdf';
          const contentType = 'application/pdf';
          this.document = `data:${contentType};base64,${attachment}`;
        })
        .finally(
          () => (this.loading = false)
        );
    },
  },
};
</script>

<style lang="scss" scoped>
.attachment-file-viewer {
  height: 100%;
  width: 100%;
}
.preview-holder {
  display: block !important;
  height: 600px;
  width: 100%;
}

.pdf-container {
  height: 100%;
  .pdf-wrapper {
    height: 100%;
    position: relative;
    min-height: 150px;
    .pdf-holder {
      height: inherit;
      text-align: center;
      line-height: 1;
      .pdf-viewer {
        max-height: 100%;
        display: inline-block;
      }
    }
  }
}
.attachments-wrapper {
  direction: rtl;
}
embed {
  width: 100%;
  height: 100%;
}
.document-text {
  font-size: 18px;
  line-height: 1.8;
  color: #6d6d6d;
}

.attachment-entry {
  border: 2px solid #a2a2a2;
  border-radius: 5px;
  cursor: pointer;
  &.outlined {
    border: 4px solid #1fb9b8;
  }

  .text-info-value {
    font-size: 14px;
    font-weight: bold;
    word-break: break-all;
  }
}
</style>